export const API_VERSION = "v1";
export const REQUEST_OTP_ENDPOINT = "/auth/otp/request/";
export const VERIFY_OTP_ENDPOINT = "/auth/otp/verify/";


export const VERIFY_TOKEN_ENDPOINT= "/user/info/";

export const GET_PAYMENT_RATE_ENDPOINT = "/pay/settings/";

export const GET_GCASH_ACCOUNT_LISTS_ENDPOINT = "/pay/gcash/acc-lists/"
export const GCASH_ADD_TRANSACTION = "/pay/gcash/add-tran/"

export const GET_CASHOUT_LISTS_ENDPOINT = "/co/list-by-user/"
export const CASHOUT_REGISTER_ENDPOINT =  "/co/register/"
export const CASHOUT_HISTORY_ENDPOINT = "/co/history/"
export const APP_LIST_ENDPOINT = "/app/list/"
export const APP_CONFIG_ENDPOINT = "/conf/app/"
export const GATE_CONFIG_ENDPOINT = "/conf/gate/"

export const GIFCODE_CLAIM_ENDPOINT = "/gc/claim/"
export const REWARD_INFO = "/rw/own/info/"
export const REWARD_FRIENDS = "/rw/fr/list/"
export const REWARD_HISTORY = "/rw/hs/list/"
export const REWARD_HISTORY_INFO = "/rw/hs/info/"